import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountLookUpSelectorViewModel } from '../../ViewModels/AccountLookUpSelectorViewModel';
import { AccountLookUp } from './AccountLookUp';
export class AccountLookUpSelector extends WMComponent {
    constructor(props) {
        super(props, AccountLookUpSelectorViewModel);
        this.onSelectItem = this.onSelectItem.bind(this);
    }
    onSelectItem(item) {
        this.viewModel.onSelectItem(item);
    }
    render() {
        if (!this.state.visible) {
            return null;
        }
        const { isMultiSelect, showMAM, isReadOnly, selectedItem, onDropDownFormOpened } = this.props;
        const { items, multiSelectDropDownItems, enabled } = this.state;
        return (_jsx(AccountLookUp, { ItemAll: this.viewModel.ItemAll, items: isMultiSelect ? multiSelectDropDownItems : items, selectedItem: selectedItem, isReadOnly: isReadOnly, isMultiSelect: isMultiSelect, isMultiSelectMode: isMultiSelect, showMAM: showMAM, enabled: enabled, onSelectItem: this.onSelectItem, onDropDownFormOpened: onDropDownFormOpened }));
    }
}
AccountLookUpSelector.defaultProps = {
    showMAM: false,
    isMultiSelect: false,
    onlyOwnAccounts: false,
    excludeMultiAsset: false,
    ignoreForceLinkingByAccount: false
};
